<template>
  <g  class="hc-hexapie-pie">
    <tagged-arc
      v-for="(a, index) in output"
      :key="index"
      :value="a"
      :outerRadius="radius"
      :innerRadius="0"
      :color="colors[index]"
      :scale="scale"
      :animation="animation"
      :animationDuration="animationDuration"
      :animationOptions="animationOptions"
    ></tagged-arc>
  </g>
</template>

<script>
import { pie } from 'd3-shape'
import TaggedArc from '../combo/TaggedArc'
export default {
  name: 'Pie',
  components: {
    TaggedArc
  },
  props: {
    data: {
      type: Array,
      default () { return [] }
    },
    radius: {
      type: Number,
      default: 116
    },
    colors: {
      type: Array,
      default () { return ['#666666', '#f56043'] }
    },
    scale: {
      type: Number,
      default: 1
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Bounce',
          easingEdge: 'Out'
        }
      }
    }
  },
  computed: {
    output () {
      return pie().sort(null)(this.data)
    },
    transform () {
      return `translate(${214 * this.scale**2} ${116 * this.scale**2}) rotate(90) scale(${this.scale})`
    }
  }
}
</script>

<style>

</style>
